export default __webpack_public_path__ + "static/media/arrow-drop-down.3ae741c8.svg";